// ABOUTME: forgot password form component for requesting password reset emails
// ABOUTME: allows users to enter email and request password reset link

import React, { useState } from "react";
import { useToast } from "../hooks/useToast";
import { requestPasswordReset } from "../services/authService";
import stylesAuth from "./AuthPage.module.css";
import styles from "./Form.module.css";

interface ForgotPasswordFormProps {
  onBackToLogin: () => void;
}

const ForgotPasswordForm: React.FC<ForgotPasswordFormProps> = ({
  onBackToLogin,
}) => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const { showSuccess, showError } = useToast();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    setMessage("");

    try {
      const response = await requestPasswordReset(email);
      setMessage(response.message);
      showSuccess(response.message);
      setEmail("");
    } catch (err) {
      const errorMessage =
        err instanceof Error ? err.message : "Failed to send reset email";
      setError(errorMessage);
      showError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <h2 className={stylesAuth.title}>Forgot Password</h2>
      <p className={stylesAuth.subtitle}>
        Enter your email address and we'll send you a link to reset your
        password.
      </p>

      <form onSubmit={handleSubmit} className={styles.form}>
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className={styles.input}
          placeholder="Enter your email"
          required
          disabled={loading}
        />

        {error && <div className={styles.error}>{error}</div>}
        {message && (
          <div
            style={{
              color: "green",
              marginBottom: "1rem",
              textAlign: "center",
            }}
          >
            {message}
          </div>
        )}

        <button
          type="submit"
          className={styles.submitBtn}
          disabled={loading || !email.trim()}
        >
          {loading ? "Sending..." : "Send Reset Link"}
        </button>
      </form>

      <div style={{ marginTop: "2rem", textAlign: "center" }}>
        <button
          type="button"
          onClick={onBackToLogin}
          className={stylesAuth.toggleBtn}
        >
          Back to Login
        </button>
      </div>
    </div>
  );
};

export default ForgotPasswordForm;
